module.exports = __webpack_public_path__ + "img/written-answers.9cdc75ea.jpg";